import { Shield, MapPin, Calendar } from "lucide-react";

type EditMode = "profile" | "password" | null;

interface ProfileHeaderProps {
  user: any;
  onEdit: (value: boolean) => void;
  setEditMode: (mode: EditMode) => void;
  activeTab: EditMode;
}
export default function ProfileHeader({
  user,
  onEdit,
  setEditMode,
  activeTab,
}: ProfileHeaderProps) {

  return (
    <div className="bg-gradient-to-r
     from-blue-600 to-indigo-700
      text-white md:p-6 p-4 rounded-xl">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex flex-col md:flex-row items-center md:items-start gap-4 text-center md:text-left">
            <div className="w-14 h-14 md:w-20 md:h-20 bg-white rounded-full 
        flex items-center justify-center  md:text-left text-center text-2xl md:text-3xl text-gray-700">
          {user?.firstName?.charAt(0)}
          </div>
   
        <div>
          <h1 className="md:text-2xl text-lg font-bold flex md:text-left md:justify-start justify-center text-center items-center gap-2">
            {user?.name}
            {user?.verified && <Shield size={20} className="text-green-300" />}
          </h1>
          <p className="text-white/80 capitalize md:text-base text-sm">{user?.role}</p>

          <div  className="flex flex-col md:flex-row items-center md:items-start gap-2 md:gap-4 text-sm text-white/80 mt-2">
            <span className="flex items-center">
              <MapPin size={16} className="mr-1 md:mt-0 mt-2" />
              {user?.city} {user?.stateName}
            </span>
            <span className="flex items-center">
              <Calendar size={16} className="mr-1" />
              Joined{" "}
              {user?.createdAt?.slice(0, 10)?.split("-").reverse().join("-")}
            </span>
          </div>
        </div>
      </div>

         <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
        <button
          onClick={() => {
            onEdit(true);
            setEditMode(activeTab); // profile ya password
          }}
          className="w-full md:w-auto bg-white/20 hover:bg-white/30 
          px-4 py-2 rounded-lg text-sm md:text-base font-medium transition"
        >
          <span>
            {activeTab === "password" ? "Edit Password" : "Edit Profile"}
          </span>
        </button>


        <button
          onClick={() => {
            onEdit(true);
            setEditMode("password");  
          }}
           className="w-full md:w-auto bg-white/20 hover:bg-white/30 
          px-4 py-2 rounded-lg text-sm md:text-base transition"
        >
          Change Password
        </button>





      </div>
           </div>


    </div>
  );
}
